import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-header" }
const _hoisted_2 = { class: "header-content" }
const _hoisted_3 = { class: "nav" }
const _hoisted_4 = { class: "nav-link" }
const _hoisted_5 = { class: "nav-link" }
const _hoisted_6 = { class: "nav-link" }
const _hoisted_7 = { class: "nav-link" }
const _hoisted_8 = { class: "nav-link" }
const _hoisted_9 = { class: "nav-trailing" }
const _hoisted_10 = {
  key: 0,
  class: "theme-nav-item"
}
const _hoisted_11 = { class: "cart-wrapper" }
const _hoisted_12 = {
  key: 0,
  class: "bet-count"
}

import { onMounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '../../stores/auth'
import { useBetslipStore } from '../../stores/betslip'
import { useModalStore } from '../../stores/modal'
import { useTheme } from '../../composables/useTheme'
import { useIntegrationMode } from '@/composables/useIntegrationMode'
import { useThemeStore } from '@/stores/theme'
import ThemeToggle from '@/components/ThemeToggle.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {

const route = useRoute()
const authStore = useAuthStore()
const betslipStore = useBetslipStore()
const modalStore = useModalStore()
const { currentTheme } = useTheme()
const themeStore = useThemeStore()
const { isLite } = useIntegrationMode()

const betCount = computed(() => betslipStore.betslip?.length || 0)

const showThemeToggle = computed(() => {
  if (isLite.value) return false
  // Single-mode themes (forceColorMode) never show the toggle.
  if (themeStore.lockedColorMode) return false
  const navigation = currentTheme.value?.navigation
  if (navigation?.hideThemeToggle) return false
  if (navigation?.forceColorMode) return false
  return true
})

const isActive = (path: string) => route.path === path

const openBetslip = () => {
  modalStore.openBetslip()
}

const getNavPath = (path: string) => {
  return { path, query: route.query }
}

const showWagers = computed(() => {
  const hideWhenUnauthenticated = currentTheme.value?.navigation?.hideWagersWhenUnauthenticated
  if (hideWhenUnauthenticated) {
    return authStore.isAuthenticated || authStore.hasValidSession()
  }
  return true
})

onMounted(() => {
  authStore.initializeFromSession()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("nav", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: getNavPath('/all'),
          class: _normalizeClass(["nav-item", { active: isActive('/all') || isActive('/next-draws') }])
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('nav.all')), 1)
          ]),
          _: 1
        }, 8, ["to", "class"]),
        _createVNode(_component_router_link, {
          to: getNavPath('/lucky-numbers'),
          class: _normalizeClass(["nav-item", { active: isActive('/lucky-numbers') }])
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('nav.luckyNumbers')), 1)
          ]),
          _: 1
        }, 8, ["to", "class"]),
        (showWagers.value)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: getNavPath('/wagers'),
              class: _normalizeClass(["nav-item", { active: isActive('/wagers') }])
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('nav.wagers')), 1)
              ]),
              _: 1
            }, 8, ["to", "class"]))
          : _createCommentVNode("", true),
        _createVNode(_component_router_link, {
          to: getNavPath('/results'),
          class: _normalizeClass(["nav-item", { active: isActive('/results') }])
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('nav.results')), 1)
          ]),
          _: 1
        }, 8, ["to", "class"]),
        _createVNode(_component_router_link, {
          to: getNavPath('/how-to-play'),
          class: _normalizeClass(["nav-item", { active: isActive('/how-to-play') }])
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('nav.howToPlay')), 1)
          ]),
          _: 1
        }, 8, ["to", "class"]),
        _createElementVNode("div", _hoisted_9, [
          (showThemeToggle.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(ThemeToggle, { layout: "nav" })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "cart-nav-item",
            onClick: openBetslip
          }, [
            _createElementVNode("div", _hoisted_11, [
              _cache[0] || (_cache[0] = _createElementVNode("img", {
                src: "/img/icons/cart.svg",
                alt: "",
                class: "cart-svg",
                "aria-hidden": "true"
              }, null, -1)),
              (betCount.value > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(betCount.value), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})